import ContactForm from "./ContactUs/ContactForm";
import OfficeLocation from "./ContactUs/OfficeLocation";
import "./Enquiry.css";

export default function Enquiry() {
  return (
    <div className="enquiry-page">
      <ContactForm showHeader />
      <OfficeLocation />
    </div>
  );
}
